<mat-tab-group>

  <mat-tab label="Report Sources">
    <mat-tab-group>
      <mat-tab label="Active">
        <ng-container *ngIf="loadingReportSources">
          <i class="fas fa-spinner fa-pulse"></i>Loading Report Sources, Please Wait...
        </ng-container>
        <ng-container *ngIf="!loadingReportSources">
          <div class="admin-grid-container">
            <div class="admin-grid-actions-container">
              <button mat-button class="piButton" (click)="addReportSource()">Create New</button>
              <button mat-button class="piButton" (click)="editSelectedReportSource()">Edit Selected</button>
              <button mat-button class="piButton" (click)="deleteSelectedReportSource()">Delete Selected</button>
              <div></div>
              <button mat-button class="piButton" (click)="resizeGrid(reportSourceDataGrid)">Auto Size Columns</button>
            </div>
            <div class="admin-grid">
              <ag-grid-angular #reportSourceDataGrid
                               style="width: 100%; height: 100%; max-height: 600px;"
                               [always]
                               class="ag-theme-alpine"
                               [rowData]="allReportSources"
                               [columnDefs]="reportSourceColumnDefs"
                               rowSelection="single"></ag-grid-angular>
            </div>
          </div>
        </ng-container>
      </mat-tab>
      <mat-tab label="Deleted">
        <ng-container *ngIf="loadingDeletedReportSources">
          <i class="fas fa-spinner fa-pulse"></i>Loading Report Sources, Please Wait...
        </ng-container>
        <ng-container *ngIf="!loadingDeletedReportSources">
          <div class="admin-grid-container">
            <div class="admin-grid-actions-container">
              <button mat-button class="piButton" (click)="unDeleteSelectedReportSource()">Un-Delete Selected</button>
              <div></div>
              <button mat-button class="piButton" (click)="resizeGrid(deletedReportSourceDataGrid)">Auto Size Columns</button>
            </div>
            <div class="admin-grid">
              <ag-grid-angular #deletedReportSourceDataGrid
                               style="width: 100%; height: 100%; max-height: 600px;"
                               [always]
                               class="ag-theme-alpine"
                               [rowData]="allDeletedReportSources"
                               [columnDefs]="reportSourceColumnDefs"
                               rowSelection="single"></ag-grid-angular>
            </div>
          </div>
        </ng-container>
      </mat-tab>
    </mat-tab-group>

  </mat-tab>

  <mat-tab label="Report Standard Types">
    <ng-container *ngIf="loadingReportStandardTypes">
      <i class="fas fa-spinner fa-pulse"></i>Loading Report Standard Types, Please Wait...
    </ng-container>
    <ng-container *ngIf="!loadingReportStandardTypes">
      <div class="admin-grid-container">
        <div class="admin-grid-actions-container">
          <button mat-button class="piButton" (click)="addReportStandardType()">Create New</button>
          <button mat-button class="piButton" (click)="editSelectedReportStandardType()">Edit Selected</button>
          <button mat-button class="piButton" (click)="deleteSelectedReportStandardType()">Delete Selected</button>
          <div></div>
          <button mat-button class="piButton" (click)="resizeGrid(reportStandardTypeDataGrid)">Auto Size Columns</button>
        </div>
        <div class="admin-grid">
          <ag-grid-angular #reportStandardTypeDataGrid
                           style="width: 100%; height: 100%; max-height: 600px;"
                           class="ag-theme-alpine"
                           [rowData]="allReportStandardTypes"
                           [columnDefs]="reportStandardTypeColumnDefs"
                           rowSelection="single"></ag-grid-angular>
        </div>
      </div>
    </ng-container>
  </mat-tab>

  <mat-tab label="Widget Types">
    <ng-container *ngIf="loadingReportEmbeddedTypes">
      <i class="fas fa-spinner fa-pulse"></i>Loading Widget Types, Please Wait...
    </ng-container>
    <ng-container *ngIf="!loadingReportEmbeddedTypes">
      <div class="admin-grid-container">
        <div class="admin-grid-actions-container">
          <button mat-button class="piButton" (click)="addReportEmbeddedType()">Create New</button>
          <button mat-button class="piButton" (click)="editSelectedReportEmbeddedType()">Edit Selected</button>
          <button mat-button class="piButton" (click)="deleteSelectedReportEmbeddedType()">Delete Selected</button>
          <div></div>
          <button mat-button class="piButton" (click)="resizeGrid(reportEmbeddedTypeDataGrid)">Auto Size Columns</button>
        </div>
        <div class="admin-grid">
          <ag-grid-angular #reportEmbeddedTypeDataGrid
                           style="width: 100%; height: 100%; max-height: 600px;"
                           class="ag-theme-alpine"
                           [rowData]="allReportEmbeddedTypes"
                           [columnDefs]="reportEmbeddedTypeColumnDefs"
                           rowSelection="single"></ag-grid-angular>
        </div>
      </div>
    </ng-container>
  </mat-tab>

  <mat-tab label="Report Subscription Types">
    <mat-tab-group>
      <mat-tab label="Active">
        <ng-container *ngIf="loadingReportSubscriptionTypes">
          <i class="fas fa-spinner fa-pulse"></i>Loading Report Subscription Types, Please Wait...
        </ng-container>
        <ng-container *ngIf="!loadingReportSubscriptionTypes">
          <div class="admin-grid-container">
            <div class="admin-grid-actions-container">
              <button mat-button class="piButton" (click)="addReportSubscriptionType()">Create New</button>
              <button mat-button class="piButton" (click)="editSelectedReportSubscriptionType()">Edit Selected</button>
              <button mat-button class="piButton" (click)="deleteSelectedReportSubscriptionType()">Delete Selected</button>
              <div></div>
              <button mat-button class="piButton" (click)="resizeGrid(reportSubscriptionTypeDataGrid)">Auto Size Columns</button>
            </div>
            <div class="admin-grid">
              <ag-grid-angular #reportSubscriptionTypeDataGrid
                               style="width: 100%; height: 100%; max-height: 600px;"
                               class="ag-theme-alpine"
                               [rowData]="allReportSubscriptionTypes"
                               [columnDefs]="reportSubscriptionTypeColumnDefs"
                               rowSelection="single"></ag-grid-angular>
            </div>
          </div>
        </ng-container>
      </mat-tab>
      <mat-tab label="Deleted">
        <ng-container *ngIf="loadingDeletedReportSubscriptionTypes">
          <i class="fas fa-spinner fa-pulse"></i>Loading Report Subscription Types, Please Wait...
        </ng-container>
        <ng-container *ngIf="!loadingDeletedReportSubscriptionTypes">
          <div class="admin-grid-container">
            <div class="admin-grid-actions-container">
              <button mat-button class="piButton" (click)="unDeleteSelectedReportSubscriptionType()">Un-Delete Selected</button>
              <div></div>
              <button mat-button class="piButton" (click)="resizeGrid(deletedReportSubscriptionTypeDataGrid)">Auto Size Columns</button>
            </div>
            <div class="admin-grid">
              <ag-grid-angular #deletedReportSubscriptionTypeDataGrid
                               style="width: 100%; height: 100%; max-height: 600px;"
                               class="ag-theme-alpine"
                               [rowData]="allDeletedReportSubscriptionTypes"
                               [columnDefs]="reportSubscriptionTypeColumnDefs"
                               rowSelection="single"></ag-grid-angular>
            </div>
          </div>
        </ng-container>
      </mat-tab>
    </mat-tab-group>

  </mat-tab>

  <!-- <mat-tab label="Report Subscription Contents">
    <ng-container *ngIf="loadingReportSubscriptionContents">
      <i class="fas fa-spinner fa-pulse"></i>Loading Report Subscription Contents, Please Wait...
    </ng-container>
    <ng-container *ngIf="!loadingReportSubscriptionContents">
      <div class="admin-grid-container">
        <div class="admin-grid-actions-container">
          <button mat-button class="piButton" (click)="noOp()">Create New</button>
          <button mat-button class="piButton" (click)="noOp()">Edit Selected</button>
          <button mat-button class="piButton" (click)="noOp()">Delete Selected</button>
          <div></div>
          <button mat-button class="piButton" (click)="noOp()">Auto Size Columns</button>
        </div>
        <div class="admin-grid">
          <ag-grid-angular #reportSubscriptionContentDataGrid
                           style="width: 100%; height: 100%"
                           class="ag-theme-alpine"
                           [rowData]="allReportSubscriptionContents"
                           [columnDefs]="reportSubscriptionContentColumnDefs"
                           rowSelection="single"></ag-grid-angular>
        </div>
      </div>
    </ng-container>
  </mat-tab> -->

  <mat-tab label="Report Subscription Levels">
    <ng-container *ngIf="loadingReportSubscriptionLevels">
      <i class="fas fa-spinner fa-pulse"></i>Loading Report Subscription Levels, Please Wait...
    </ng-container>
    <ng-container *ngIf="!loadingReportSubscriptionLevels">
      <div class="admin-grid-container">
        <div class="admin-grid-actions-container">
          <button mat-button class="piButton" (click)="addReportSubscriptionLevel()">Create New</button>
          <button mat-button class="piButton" (click)="editSelectedReportSubscriptionLevel()">Edit Selected</button>
          <button mat-button class="piButton" (click)="deleteSelectedReportSubscriptionLevel()">Delete Selected</button>
          <div></div>
          <button mat-button class="piButton" (click)="resizeGrid(reportSubscriptionLevelDataGrid)">Auto Size Columns</button>
        </div>
        <div class="admin-grid">
          <ag-grid-angular #reportSubscriptionLevelDataGrid
                           style="width: 100%; height: 100%; max-height: 600px;"
                           class="ag-theme-alpine"
                           [rowData]="allReportSubscriptionLevels"
                           [columnDefs]="reportSubscriptionLevelColumnDefs"
                           rowSelection="single"></ag-grid-angular>
        </div>
      </div>
    </ng-container>
  </mat-tab>

  <mat-tab label="Report Subscription Prices">
    <ng-container *ngIf="loadingReportSubscriptionPrices">
      <i class="fas fa-spinner fa-pulse"></i>Loading Report Subscription Prices, Please Wait...
    </ng-container>
    <ng-container *ngIf="!loadingReportSubscriptionPrices">
      <div class="admin-grid-container">
        <div class="admin-grid-actions-container">
          <button mat-button class="piButton" (click)="addReportSubscriptionPrice()">Create New</button>
          <button mat-button class="piButton" (click)="editSelectedReportSubscriptionPrice()">Edit Selected</button>
          <button mat-button class="piButton" (click)="deleteSelectedReportSubscriptionPrice()">Delete Selected</button>
          <button mat-button class="piButton" (click)="copyReportSubscriptionPricePurchaseUrl()">Copy Purchase URL</button>
          <div></div>
          <button mat-button class="piButton" (click)="resizeGrid(reportSubscriptionPriceDataGrid)">Auto Size Columns</button>
        </div>
        <div class="admin-grid">
          <ag-grid-angular #reportSubscriptionPriceDataGrid
                           style="width: 100%; height: 100%; max-height: 600px;"
                           class="ag-theme-alpine"
                           [rowData]="allReportSubscriptionPrices"
                           [columnDefs]="reportSubscriptionPriceColumnDefs"
                           rowSelection="single"></ag-grid-angular>
        </div>
      </div>
    </ng-container>
  </mat-tab>

</mat-tab-group>
